import { useMediaQuery } from 'react-responsive';

enum SCREENS {
  SMALL = 'sm', // 0 - 767px - Mobile
  MEDIUM = 'md', // 768 - 1023px - Tablet
  LARGE = 'lg', // 1024 - 1279px - Laptop
  XLARGE = 'xl', // 1280 - 1919px - Desktop
  XXLARGE = 'xxl', // 1920px and above - Large Desktop
}
const screenBreakpoints = {
  tablet: { minWidth: 768, maxWidth: 1023 },
  laptop: { minWidth: 1024 },
  desktop: { minWidth: 1280, maxWidth: 1919 },
  largeDesktop: { minWidth: 1920 },
}
const getScreenVariant = () => {
  const isTablet = useMediaQuery(screenBreakpoints.tablet);
  const isLaptop = useMediaQuery(screenBreakpoints.laptop);
  const isDesktop = useMediaQuery(screenBreakpoints.desktop);
  const isLargeDesktop = useMediaQuery(screenBreakpoints.largeDesktop);

  let screenType = SCREENS.LARGE;

  if (isLargeDesktop) {
    screenType = SCREENS.XXLARGE;
  } else if (isDesktop) {
    screenType = SCREENS.XLARGE;
  } else if (isLaptop) {
    screenType = SCREENS.LARGE;
  } else if (isTablet) {
    screenType = SCREENS.MEDIUM;
  }

  return screenType;
}

export { getScreenVariant, SCREENS };